import { useEffect, useRef, useState, type Dispatch, type SetStateAction } from "react";

/**
 * 鑑賞モード（フルスクリーン再生オーバーレイ）の表示状態。
 *
 * 共有リンク（`?work=`）から開いたときだけ、受け取った人がまず作品として
 * 観られるよう自動で開く。トラックが揃うのを待ってから 1 回だけ開き、
 * ユーザーが閉じたあとは曲送りしても開き直さない。
 *
 * @param openInAppreciation 共有リンク由来か（自動オープンの対象か）
 * @param hasTrack 再生対象のトラックが決まっているか
 */
export const useAppreciationAutoOpen = (
  openInAppreciation: boolean,
  hasTrack: boolean,
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [showAppreciation, setShowAppreciation] = useState(false);
  const autoOpenedRef = useRef(false);

  useEffect(() => {
    if (!openInAppreciation || autoOpenedRef.current) return;
    if (!hasTrack) return;
    autoOpenedRef.current = true;
    setShowAppreciation(true);
  }, [openInAppreciation, hasTrack]);

  return [showAppreciation, setShowAppreciation];
};
